export function isNotEmptyArray<T>(array: T[] | undefined): array is T[] {
	return array != null && 0 < array.length;
}

export const adCopyMb = 1024 * 1024;
